import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postSignOfferingTransactionDocuments } from '@arrived/api_v2';
import { OfferingTransaction, SignDocumentRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { accountTradesQueryKeyFn, tradeQueryKeyFn, userTradesQueryKeyFn } from '../trades';

export function usePostSignTradeMutation(options?: UseMutationOptions<OfferingTransaction, SignDocumentRequest>) {
  const queryClient = useQueryClient();

  return useMutation((signDocumentRequest) => postSignOfferingTransactionDocuments(signDocumentRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { id: tradeId, accountId, userId } = data;

      queryClient.invalidateQueries(tradeQueryKeyFn(tradeId));
      queryClient.invalidateQueries(userTradesQueryKeyFn(userId));
      queryClient.invalidateQueries(accountTradesQueryKeyFn(accountId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
